
export const BASE_END_POINT = 'https://api-stg.saaei.co/api/v1/' 